/* AmazeDeals Mystery Box Theme — JS */

document.addEventListener('DOMContentLoaded', () => {

  // ── FAQ Accordion ─────────────────────────────────
  document.querySelectorAll('.ad-faq__q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.ad-faq__item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.ad-faq__item.open').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── Testimonials Carousel ─────────────────────────
  const track = document.querySelector('.ad-testimonials__track');
  const dots  = document.querySelectorAll('.ad-testimonials__dot');
  if (track && dots.length) {
    let current = 0;
    const cards = track.querySelectorAll('.ad-testimonials__card');
    const visible = window.innerWidth < 768 ? 1 : window.innerWidth < 1024 ? 2 : 3;
    const max = Math.max(0, cards.length - visible);

    function goTo(i) {
      current = Math.min(i, max);
      const w = cards[0]?.offsetWidth + 24;
      track.style.transform = `translateX(-${current * w}px)`;
      dots.forEach((d, idx) => d.classList.toggle('active', idx === current));
    }

    dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));
    goTo(0);

    // Auto-advance
    setInterval(() => goTo(current >= max ? 0 : current + 1), 4500);
  }

  // ── Scroll animations ─────────────────────────────
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('ad-visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll(
    '.ad-box-card, .ad-trust__item, .ad-how__step, .ad-why__card, .ad-testimonials__card, .ad-faq__item'
  ).forEach((el, i) => {
    el.style.transitionDelay = `${i * 60}ms`;
    el.classList.add('ad-fade-up');
    observer.observe(el);
  });

});

/* Scroll animation styles injected */
const s = document.createElement('style');
s.textContent = `
  .ad-fade-up { opacity: 0; transform: translateY(24px); transition: opacity 0.5s ease, transform 0.5s ease; }
  .ad-fade-up.ad-visible { opacity: 1; transform: translateY(0); }
`;
document.head.appendChild(s);
